import styles from "components/sections/search/store/StoreSearchResult.module.scss";
import RecommendedQueries from "components/sections/search/RecommendedQueries";
import {KEY_STORE} from "components/sections/search/SearchResult";
import {useRouter} from "next/router";
import StoreSearchResultSecond from "components/sections/search/store/StoreSearchResultSecond";
import StoreSearchResultFirst from "components/sections/search/store/StoreSearchResultFirst";

const StoreSearchResult = (props) => {
    const {setQuery, recommendedQueries} = props;

    const router = useRouter();

    const phase = router.query.phase || '1';

    const isSearchRequested = Boolean(router.query.q) || Boolean(router.query.brands) || Boolean(router.query.categories);

    return (
        <>
            {
                isSearchRequested ?
                    <>
                        {
                            phase === '1' ?
                                <StoreSearchResultFirst/> :
                                <StoreSearchResultSecond/>
                        }
                    </> :
                    <div className={styles.recommendedQueriesContainer}>
                        <RecommendedQueries
                            category={KEY_STORE}
                            searchQuery={setQuery}
                            recommendedQueries={recommendedQueries}
                        />
                    </div>
            }
        </>
    );

}

export default StoreSearchResult;
